import { z } from "zod";
import { idSchema } from "./common.ts";
import type { PublicCategory } from "./menu.ts";
import { idempotencyKeySchema, orderLineInputSchema } from "./orders.ts";

/** Staff order entry. No table means a counter / takeaway order; `label` names it on tickets. */
export const posOrderSchema = z.object({
  menuId: idSchema,
  tableId: idSchema.nullable(),
  label: z.string().trim().max(40).optional(),
  idempotencyKey: idempotencyKeySchema,
  notes: z.string().max(500).optional(),
  items: z.array(orderLineInputSchema).min(1).max(60),
});
export type PosOrderInput = z.infer<typeof posOrderSchema>;

export const voidLineSchema = z.object({ reason: z.string().trim().min(1).max(200) });
export const settleOrdersSchema = z.object({ orderIds: z.array(idSchema).min(1).max(100) });

export type PosMenuDto = {
  id: string;
  name: string;
  defaultLanguage: string;
  categories: PublicCategory[];
};

export type PosConfigDto = {
  currency: string;
  taxInclusive: boolean;
  menus: PosMenuDto[];
  unavailableItemIds: string[];
  unavailableOptionIds: string[];
};
